import { render, staticRenderFns } from "./importTraderDialog.vue?vue&type=template&id=2beb5b2f&scoped=true"
import script from "./importTraderDialog.vue?vue&type=script&lang=js"
export * from "./importTraderDialog.vue?vue&type=script&lang=js"
import style0 from "./importTraderDialog.vue?vue&type=style&index=0&id=2beb5b2f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2beb5b2f",
  null
  
)

export default component.exports